import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NoDataContent } from "../../components/EmptyDataComponent/NoDataContent";
// import CountDisplay from "../../components/CollegeAdminComponents/CountDisplay";

const TABLE_HEAD = ["Name", "Email", "College", "REGISTRATION ID", "Status", ""];

export const AdmitParticipantPage = () => {
  const { state } = useLocation();
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
  const [userList, setUserList] = useState(null);
  const [filter, setFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [unfilteredData, setUnfilteredData] = useState({
    users: [],
    pagination: {},
  });


  const navigate = useNavigate();

  const navigateToSpotRegistration = () => {
    navigate('spot-admission');
  }

  const handleRegister = async (id, admittedForEvent) => {
      try {
        const accessToken = JSON.parse(localStorage.getItem("token")).token;
        const response = await fetch(`${BASE_URL}/api/eventregistrations/${id}/admit`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ isAdmitted: !admittedForEvent }),
        });

        if (response.status === 401) {
          alert("Session Expired, Please login again");
          localStorage.removeItem("token");
          navigate("/");
        }

        if (!response) throw new Error("Network failure");

        await response.json();
        fetchUserList();
      } catch (err) {
        console.error(err.message);
      }
  };


  const fetchUserList = async () => {
    try {
      setUserList(null);
      const accessToken = JSON.parse(localStorage.getItem("token")).token;
      const response = await fetch(`${BASE_URL}/api/eventregistrations/events/${searchTerm}/selected`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/");
      }

      const { selectedForEvent } = await response.json();
    //   setSelectedForEventCount(selectedForEvent.length);
      const data = {
        users: [
          ...selectedForEvent.map((user) => ({ ...user, selected: true })),
        ],
        pagination: {},
      };
      setUserList(data);
      setUnfilteredData(data);
    } catch (err) {
      console.error(err.message);
    }
  };


  useEffect(() => {
    const role = JSON.parse(localStorage.getItem("token")).role;
    if(role !== "ADMISSION_OFFICER") {
      navigate("/forbidden");

    }
    // fetchUserList();
  }, []);

  // useEffect(() => {
  //   if (!unfilteredData || unfilteredData.users.length === 0) return;

  //   const filteredUsers = unfilteredData.users
  //     .filter((user) => {
  //       if (filter === "selected") return user.selected;
  //       // if (filter === "notSelectedForEvent") return !user.selected;
  //       return true;
  //     })
  //     .filter((user) =>
  //       user.userId.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       user.userId.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       user.collegeId?.collegeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       user.registrationId.toLowerCase().includes(searchTerm.toLowerCase())
  //     );

  //   setUserList({ ...unfilteredData, users: filteredUsers });
  // }, [filter, searchTerm, unfilteredData]);

  return (
    <section>
      <div className=" top-0 w-full py-4 flex justify-between items-center">
        <span className="ml-4 text-lg opacity-60 font-semibold uppercase">
          Admit Participants
        </span>
        <div className="flex gap-2 w-3/4 ">
          {/* <CountDisplay x={selectedForEventCount} y={state.maxParticipants} /> */}

          <input
            type="text"
            placeholder="Search by registration ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="px-3 py-3 w-1/2 border-2 border-black rounded-md"
          />
          {/* {["all", "selected", "notSelectedForEvent"].map((filterType) => (
            <button
              key={filterType}
              className={`px-3 py-1 text-sm border-2 shadow rounded-md transition duration-200 ${
                filter === filterType
                  ? `bg-${filterType === "all" ? "zinc" : filterType === "selected" ? "green" : "red"}-600 text-white`
                  : `bg-white text-black`
              } border-${filterType === "all" ? "zinc" : filterType === "selected" ? "green" : "red"}-600`}
              onClick={() => setFilter(filterType)}
            >
              {filterType === "all" ? "All" : filterType.charAt(0).toUpperCase() + filterType.slice(1)}
            </button>
          ))} */}
          <button onClick={handleRegister} className="bg-blue-600 p-4 text-white rounded-lg text-lg hover:bg-blue-400">
            search
          </button>
        </div>
      </div>

      {userList && userList.users.length > 0 ? (
        <table className="w-full text-left rounded overflow-hidden">
          <thead className="border-b-2 border-black border-opacity-20">
            <tr>
              {TABLE_HEAD.map((eachHead) => (
                <th key={eachHead} className="border-b border-blue-gray-50 p-4">
                  {eachHead}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {userList.users.map((eachRow) => (
              <tr key={eachRow.id}>
                {console.log(eachRow)}
                <td className="p-4 border-b border-blue-50">{eachRow.userId.username}</td>
                <td className="p-4 border-b border-blue-50">{eachRow.userId.email}</td>
                <td className="p-4 border-b border-blue-50">{eachRow.collegeId?.collegeName}</td>
                <td className="p-4 border-b border-blue-50">{eachRow.registrationId}</td>
                <td className="p-4 border-b border-blue-50">
                  <button
                    onClick={() => handleRegister(eachRow.registrationId, eachRow.attendanceStatus)}
                    className={`p-2 pr-4 text-xs flex justify-center items-center ${
                      eachRow.attendanceStatus ? "bg-green-600" : "bg-red-600"
                    } bg-opacity-40 hover:bg-opacity-50 duration-200 font-bold rounded`}
                  >
                    {eachRow.attendanceStatus ? "Admitted" : "Not Admitted"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <NoDataContent message="Please Enter first 8 characters of the ID" />
      )}
    </section>
  );
};
